__turbopack_context__.v({
  "className": "noto_serif_8cd51d61-module__ozTvVW__className",
  "variable": "noto_serif_8cd51d61-module__ozTvVW__variable",
});
